var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-field-radio-buttons',{staticStyle:{"min-width":"260px"},attrs:{"radio-class":_vm.tempClass,"items":_vm.availableTemps,"expanded":""},on:{"change":_vm.changeTempClass},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }